import {useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {Offcanvas} from "react-bootstrap";

const NAV_ITEMS = [
    {to: "/simulator", label: "הצעות / תמהילים", icon: "bi-sliders"},
    {to: "/assets", label: "נכסים", icon: "bi-building"},
    {to: "/dashboard", label: "דשבורד תרחישים", icon: "bi-bar-chart-line"},
];

function NavLinks({pathname, onNavigate}) {
    return (
        <div className="sidebar-rail">
            {NAV_ITEMS.map((item, i) => {
                const active = pathname === item.to;
                return (
                    <Link
                        key={item.to}
                        to={item.to}
                        aria-current={active ? "page" : undefined}
                        className={`sidebar-step${active ? " active" : ""}`}
                        onClick={onNavigate}
                    >
                        <span className="step-track"><span className="step-dot"></span></span>
                        <span className="step-num">{String(i + 1).padStart(2, "0")}</span>
                        <i className={`bi ${item.icon} step-icon`}></i>
                        <span className="step-label">{item.label}</span>
                    </Link>
                );
            })}
        </div>
    );
}

function ConsultantSidebar() {
    const location = useLocation();
    const [open, setOpen] = useState(false);

    return (
        <>
            <button className="sidebar-toggle" onClick={() => setOpen(true)} aria-label="פתח ניווט">
                <i className="bi bi-list"></i>
            </button>

            <div className="sidebar">
                <div className="sidebar-eyebrow">ניווט</div>
                <NavLinks pathname={location.pathname} />
            </div>

            <Offcanvas show={open} onHide={() => setOpen(false)} placement="end" className="sidebar-offcanvas" backdropClassName="sidebar-offcanvas-backdrop">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>ניווט</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <NavLinks pathname={location.pathname} onNavigate={() => setOpen(false)} />
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}

export default ConsultantSidebar;
